import {
    buildAddLayerMapping,
    buildMoveLayerMapping,
    buildRemoveLayerMapping,
} from "@app/common/components/viewers/configurator/extensions/bd-cloud/helpers/layers"

export type StackLayer = {
    name: string
    inputParameterIds: string[]
    stackId: string
    layerId: number
}

type LayerMapping = {
    mapping: Map<number, number>
    newCount: number
}

export class LayerStack {
    readonly layers: readonly StackLayer[]
    private readonly reversed: boolean

    constructor(layers: StackLayer[], reversed: boolean = false) {
        this.layers = [...layers].sort((a, b) => a.layerId - b.layerId)
        this.reversed = reversed
    }

    get layerCount(): number {
        return this.layers.length
    }

    getDisplayLayers(): readonly StackLayer[] {
        return this.reversed ? [...this.layers].reverse() : this.layers
    }

    displayIndexToTemplateIndex(displayIndex: number): number {
        if (!this.reversed) return displayIndex
        return this.layerCount - 1 - displayIndex
    }

    buildAddMapping(displayInsertIndex: number): LayerMapping {
        const templateIndex = this.reversed ? this.layerCount - displayInsertIndex : displayInsertIndex
        return {
            mapping: buildAddLayerMapping(this.layerCount, templateIndex),
            newCount: this.layerCount + 1,
        }
    }

    buildRemoveMapping(displayIndex: number): LayerMapping {
        const templateIndex = this.displayIndexToTemplateIndex(displayIndex)
        return {
            mapping: buildRemoveLayerMapping(this.layerCount, templateIndex),
            newCount: this.layerCount - 1,
        }
    }

    buildMoveMapping(displaySourceIndex: number, displayTargetIndex: number): LayerMapping {
        const templateSource = this.displayIndexToTemplateIndex(displaySourceIndex)
        const templateTarget = this.displayIndexToTemplateIndex(displayTargetIndex)
        return {
            mapping: buildMoveLayerMapping(this.layerCount, templateSource, templateTarget),
            newCount: this.layerCount,
        }
    }

    canMove(displaySourceIndex: number, displayTargetIndex: number): boolean {
        return (
            displaySourceIndex !== displayTargetIndex &&
            displaySourceIndex >= 0 &&
            displaySourceIndex < this.layerCount &&
            displayTargetIndex >= 0 &&
            displayTargetIndex < this.layerCount
        )
    }
}
